export default __webpack_public_path__ + "static/media/bag.fba152a2.jpg";